import api from ".";
import { ICriteriaDetails } from "../types/criteriaDetails";
import cookiesModifier from "../utils/cookies";

export const createCriteriaDetails = async (data: ICriteriaDetails) => {
    const url = `criteria-details`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateCriteriaDetails = async (data: ICriteriaDetails) => {
    try {
        const { id, ...payload } = data;
        const url = `criteria-details/${id}`;
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(url, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteCriteriaDetails = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`criteria-details/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}